import { cn } from '@heroui/react';
import { FC } from 'react';

import i18n from '~/common/helpers/i18n';
import { AiNativeIcon } from '~/components/icons';

interface DigitalWorkerTagProps {
  showLabel?: boolean;
  className?: string;
}

export const DigitalWorkerTag: FC<DigitalWorkerTagProps> = ({
  showLabel = false,
  className = ''
}) => (
  <span
    data-testid='digital-worker-tag'
    title={showLabel ? undefined : i18n.t('label.created_by_digital_worker')!}
    className={cn(
      'inline-flex shrink-0 items-center gap-1 rounded bg-secondary-container text-on-secondary-container',
      showLabel ? 'px-[5px]' : 'px-[3px]',
      className
    )}
  >
    {showLabel ? (
      <span className='whitespace-nowrap text-[10px] font-semibold uppercase leading-5 tracking-[1px]'>
        {i18n.t('label.created_by_digital_worker')}
      </span>
    ) : null}
    <AiNativeIcon size={20} className='shrink-0' />
  </span>
);
